import "./Main.css";

function Main() {
  return <div className="main">main</div>;
}

export default Main;
